import socket from './socket';

const getEmployeePlans = (pointSystemId, headers) =>
  socket.get(`/point-systems/${pointSystemId}/employee-plans`, undefined, headers);

const createEmployeePlan = (pointSystemId, data, headers) =>
  socket.post(`/point-systems/${pointSystemId}/employee-plans`, data, headers);

const updateEmployeePlan = (id, data, headers) => socket.patch(`/employee-plans/${id}`, data, headers);

const deleteEmployeePlan = (id, headers) => socket.delete(`/employee-plans/${id}`, undefined, headers);

export default {
  getEmployeePlans,
  createEmployeePlan,
  updateEmployeePlan,
  deleteEmployeePlan,
};

